import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    private searchSubject           = new Subject<any>();
    private categoryListSubject     = new Subject<any>();
    private categorySelectedSubject = new Subject<any>();
    public defaultCategorySubject   = new Subject<any>();
    public routeIdSubject           = new Subject<any>();
    public cartCountSubject         = new Subject<any>();
    private allFilterData: any      = {};
    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();
    
    constructor() { }

    sendSearchResult(searchResult: string) {
        this.searchSubject.next(searchResult);
    }

    sendCategory(category: any) {
        this.categoryListSubject.next(category);
    }

    sendSelectedCategory(id: any, name: any, category: any, event: any) {
        event.checked = true;
        this.categorySelectedSubject.next({ id, name, category, event });
    }

    changeDefaultCategory(category: any) {
        this.defaultCategorySubject.next(category);
    }

    sendRouteId(id: any) {
        this.routeIdSubject.next(id);
    }

    sendCartCount(count: any) {
        this.cartCountSubject.next(count);
    }

    setFilterData(filterData: any) {
        this.allFilterData = { ...filterData };
    }
    
    getFilterData() {
        return { ...this.allFilterData };
    }

    resetFilterData() {
        this.allFilterData = {};
    }

    getFilterDataLength() {
        //console.log(this.allFilterData);
        // return this.allFilterData && this.allFilterData.filterArray !== null && this.allFilterData.filterArray !== undefined 
        //     ? this.allFilterData.filterArray.length
        //     : 0;
        // const excludedProperties = ['currentPage', 'sortSelection', 'sortBy', 'currentCategory'];
        // const filteredProperties = Object.keys(this.allFilterData).filter(key => !excludedProperties.includes(key));
        const filteredProperties = Object.keys(this.allFilterData);
        return filteredProperties.length;
    }

    getCurrentPage() {
        return this.allFilterData && this.allFilterData.currentPage !== null && this.allFilterData.currentPage !== undefined 
            ? this.allFilterData.currentPage : 0;
    }

    getSortData() {
        return this.allFilterData && this.allFilterData.sortSelected !== null && this.allFilterData.sortSelected !== undefined 
            ? this.allFilterData.sortSelected : false;
    }

    getSearchResult(): Observable<any> {
        return this.searchSubject.asObservable();
    }

    getCategoryResult(): Observable<any> {
        return this.categoryListSubject.asObservable();
    }

    getSelectedCategory(): Observable<any> {
        return this.categorySelectedSubject.asObservable();
    }

    getRouteId(): Observable<any> {
        return this.routeIdSubject.asObservable();
    }

    getCartCount(): Observable<any> {
        return this.cartCountSubject.asObservable();
    }
    setLoading(isLoading: boolean) {
        this.loadingSubject.next(isLoading);
      }
    
}